import axios from "axios";

export const state = {
    labservices: [],
};

export const getters = {
    labservices: state => state.labservices,
};

export const mutations = {
    setServices(labservices, newValue) { state.labservices = newValue},
};

export const actions = {
    fetchLabServices({ commit }) {
        axios.get('/labservices').then(res => {
            commit('setServices', res.data.labservices)
        })
    },
};
